import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const data = [{
  day: 'Mon',
  nurses: 12,
  caregivers: 24,
  support: 8
}, {
  day: 'Tue',
  nurses: 10,
  caregivers: 22,
  support: 7
}, {
  day: 'Wed',
  nurses: 11,
  caregivers: 24,
  support: 8
}, {
  day: 'Thu',
  nurses: 12,
  caregivers: 23,
  support: 8
}, {
  day: 'Fri',
  nurses: 12,
  caregivers: 25,
  support: 9
}, {
  day: 'Sat',
  nurses: 8,
  caregivers: 18,
  support: 6
}, {
  day: 'Sun',
  nurses: 8,
  caregivers: 18,
  support: 6
}];
export const StaffingLevelsChart: React.FC = () => {
  return <ResponsiveContainer width="100%" height="100%" data-id="element-63">
      <BarChart data={data} margin={{
      top: 5,
      right: 30,
      left: 20,
      bottom: 5
    }} data-id="element-64">
        <CartesianGrid strokeDasharray="3 3" data-id="element-65" />
        <XAxis dataKey="day" data-id="element-66" />
        <YAxis data-id="element-67" />
        <Tooltip data-id="element-68" />
        <Legend data-id="element-69" />
        <Bar dataKey="nurses" fill="#255db7" data-id="element-70" />
        <Bar dataKey="caregivers" fill="#f97c6b" data-id="element-71" />
        <Bar dataKey="support" fill="#f6d052" data-id="element-72" />
      </BarChart>
    </ResponsiveContainer>;
};